/** KAN-810: actions over the selected leads; shown only while something is selected. */
import { Button } from '@/components/ui/button';

interface LeadBulkBarProps {
  count: number;
  busy: boolean;
  exporting: boolean;
  onExport: () => void;
  onAssignManager: () => void;
  onMarkTransferred: () => void;
  onUnmarkTransferred: () => void;
  onClear: () => void;
}

export function LeadBulkBar({
  count,
  busy,
  exporting,
  onExport,
  onAssignManager,
  onMarkTransferred,
  onUnmarkTransferred,
  onClear,
}: LeadBulkBarProps) {
  if (count === 0) return null;
  return (
    <div
      data-testid="lead-bulk-bar"
      className="flex flex-wrap items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2"
    >
      <span className="text-sm font-medium text-gray-800">Выбрано: {count}</span>
      <Button size="sm" variant="outline" onClick={onExport} disabled={exporting}>
        Выгрузить в Excel
      </Button>
      <Button size="sm" variant="outline" onClick={onAssignManager} disabled={busy}>
        Назначить менеджера
      </Button>
      <Button size="sm" variant="outline" onClick={onMarkTransferred} disabled={busy}>
        Отметить переданными
      </Button>
      <Button size="sm" variant="outline" onClick={onUnmarkTransferred} disabled={busy}>
        Снять отметку
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear}>
        Сбросить выбор
      </Button>
    </div>
  );
}
